import gsap from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { animateObserver, fadeIn } from "../../../js/animations/animations";

(() => {
  const BRHCompositionAwards = () => {
    const selectors = {
      component: ".brh-composition-awards",
      container: "brh-composition-awards__content",
      textIcon: "brh-text-icon",
    };

    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        const parentElement = Array.from(document.querySelectorAll(selectors.component));
        parentElement.forEach((element) => {
          if (element) {
            const appearances = gsap.timeline();
            const componentContent = element.querySelector(".js-composition-awards");
            const awards = element.querySelectorAll(".brh-text-icon");
            awards.length > 0 && appearances.add(fadeIn({ classElement: awards, duration: 2 }), 0);
            appearances.duration(3);
            appearances.pause();
            animateObserver({ elementToObserve: componentContent, animation: () => appearances, threshold: 0 });
          }
        });
      }
      if (isMobile() && !isAuthor()) {
        const parentElement = Array.from(document.querySelectorAll(selectors.component));
        parentElement.forEach((element) => {
          const textIconElements = element.querySelectorAll("." + selectors.container + " ." + selectors.textIcon);
          if (textIconElements?.length > 2) {
            const swiperElement = element.querySelector("." + selectors.container);
            swiperElement.classList.add("slider");

            const swiperWrapper = swiperElement.querySelector(".brh-composition-awards__swiper-wrapper");
            textIconElements.forEach((textIcon) => {
              textIcon.classList.add("swiper-slide");
              swiperWrapper.insertAdjacentElement("beforeend", textIcon);
            });

            element.querySelector(".brh-composition-awards__swiper-navigations")?.classList.remove("hidden");

            new window.Swiper(swiperElement, {
              slidesPerView: 2,
              freeMode: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
              },
            });
          }
        });
      }

      // If the Composition Awards has the cta configured, then add the "mod--expand" class so that the cta will have the right margin
      // Otherwise, the wrapper will have the margin bottom as in the Figma by default and the CTA won't have any margin
      const compositionAwards = document.querySelector(selectors.component);
      if (compositionAwards) {
        const cta = compositionAwards.querySelector(".js-composition-awards-cta");
        if (cta && cta.children.length > 0) {
          compositionAwards.classList.add("mod--expand");
        }
      }
    };

    init();
  };
  document.addEventListener("DOMContentLoaded", BRHCompositionAwards);
})();
